module.exports = __webpack_public_path__ + "static/ProximaNova-Bold-3b70f0d9979f78e3780fd77269c3fe9f.woff";